import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M15.437 3.066a5.83 5.83 0 0 0-3.63-1.033 5.645 5.645 0 0 0-5.47 4.406v.001c-.066.306-.1.631-.134.949l-.023.221H3.437l-.02.207-.444 4.42a7617 7617 0 0 0-.948 9.49L2 21.979h20l-.025-.252-.439-4.387c-.317-3.174-.634-6.346-.956-9.53l-.021-.206h-2.756a5.52 5.52 0 0 0-2.366-4.538m-.998 1.569a3.9 3.9 0 0 0-2.59-.746h-.014a3.8 3.8 0 0 0-2.493.954l-.002.002A3.72 3.72 0 0 0 8.05 7.59h7.907a3.74 3.74 0 0 0-1.519-2.955M5.102 9.467 4.065 20.126h15.87L18.898 9.468l-1.1.003v.133c0 .363-.001.713.006 1.063q.01.024.031.04l.007.005a1.61 1.61 0 0 1 .643 1.186 1.62 1.62 0 0 1-3.063.852 1.62 1.62 0 0 1 .5-2.055l.014-.012c.007-.364.006-.726.005-1.092v-.113H8.05v1.127l-.001.011a.12.12 0 0 0 .052.111l.01.007a1.61 1.61 0 0 1 .259 2.32 1.624 1.624 0 0 1-2.308.187 1.57 1.57 0 0 1-.119-2.308l.006-.006.007-.006a.74.74 0 0 0 .245-.66L6.2 10.25v-.01a9 9 0 0 1-.004-.578l.003-.195z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }